module.exports = __webpack_public_path__ + "img/catseye03.8f9f1a69.jpg";